<xemex-dialog-shell [title]="'alarmsPage.settings.deviceOverridesDialog.title' | translate">
  <div class="flex flex-col gap-4">
    <p class="text-sm text-text-secondary">
      {{
        (overrideCount() === 1
          ? 'alarmsPage.settings.deviceOverridesDialog.description'
          : 'alarmsPage.settings.deviceOverridesDialog.descriptionPlural'
        ) | translate: { count: overrideCount(), alarmType: data.alarmTypeLabel }
      }}
    </p>

    <xemex-table-global-row
      [columns]="columns"
      [label]="'alarmsPage.settings.deviceOverridesDialog.globalSetting' | translate"
      [values]="{
        showInPortal: globalShowInPortal(),
        emailNotification: globalEmailNotification(),
      }"
      actionsWidth="3rem"
      (toggleChange)="onGlobalToggleChange($event)"
    ></xemex-table-global-row>

    @if (globalSettingChanged()) {
      <div
        class="flex items-center gap-2 rounded-lg border border-amber-300 bg-status-warning p-3 text-sm text-amber-800"
      >
        <mat-icon class="shrink-0 text-amber-500 !text-[20px] !w-5 !h-5">warning</mat-icon>
        <span>{{
          'alarmsPage.settings.deviceOverridesDialog.globalSettingChangedWarning' | translate
        }}</span>
      </div>
    }

    @if (selectedKeys().size > 0) {
      <div
        class="flex items-center gap-3 rounded-lg border border-border-default bg-surface-highlight p-3 text-sm"
      >
        <span class="font-medium text-text-default">{{
          'alarmsPage.settings.deviceOverridesDialog.bulk.selectedCount'
            | translate: { count: selectedKeys().size }
        }}</span>
        <span class="flex-1"></span>
        <div class="flex items-center gap-2 text-text-secondary">
          <span>{{ 'alarmsPage.settings.deviceOverridesDialog.columns.showInPortal' | translate }}</span>
          <mat-slide-toggle
            [checked]="bulkShowInPortal()"
            (change)="setBulkShowInPortal(!bulkShowInPortal())"
          ></mat-slide-toggle>
        </div>
        <div class="flex items-center gap-2 text-text-secondary">
          <span>{{ 'alarmsPage.settings.deviceOverridesDialog.columns.email' | translate }}</span>
          <mat-slide-toggle
            [checked]="bulkEmailNotification()"
            (change)="setBulkEmailNotification(!bulkEmailNotification())"
          ></mat-slide-toggle>
        </div>
        <button mat-button type="button" (click)="removeOverrideForSelection()">
          {{ 'alarmsPage.settings.deviceOverridesDialog.bulk.removeOverride' | translate }}
        </button>
      </div>
    }

    <xemex-table
      [data]="filteredDevices()"
      [columns]="columns"
      [pageable]="true"
      [selectable]="true"
      [selectionKey]="selectionKey"
      [selectedKeys]="selectedKeys()"
      actionsWidth="3rem"
      (toggleChange)="onToggleChange($event)"
      (selectedKeysChange)="onSelectedKeysChange($event)"
    >
      <xemex-search-input
        [placeholder]="'alarmsPage.settings.deviceOverridesDialog.searchPlaceholder' | translate"
        (valueChange)="query.set($event)"
      ></xemex-search-input>

      <ng-template #actionsCell let-row>
        <button
          mat-icon-button
          type="button"
          [title]="'alarmsPage.settings.deviceOverridesDialog.hint' | translate"
          (click)="viewDeviceSettings(row)"
        >
          <mat-icon>chevron_right</mat-icon>
        </button>
      </ng-template>
    </xemex-table>
  </div>

  <div actions class="flex w-full items-center justify-between gap-4">
    <span class="text-sm text-text-secondary">{{
      'alarmsPage.settings.deviceOverridesDialog.hint' | translate
    }}</span>
    <div class="flex items-center gap-2">
      <button mat-button type="button" [disabled]="saving()" (click)="close()">
        {{ 'alarmsPage.settings.deviceOverridesDialog.close' | translate }}
      </button>
      <xemex-filled-button type="button" [disabled]="saving()" (click)="saveChanges()">
        {{ 'alarmsPage.settings.deviceOverridesDialog.save' | translate }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
